import React from "react"
import makeStyles from "@mui/styles/makeStyles"
import { connect } from "react-redux"
import ReceptionWarehouseTable from "./ReceptionWarehouseTable"

const useClasses = makeStyles(() => ({
    container: {
        width: "100%"
    }
}))

const ReceptionWarehouseDone = (props) => {
    const {
        modalRef,
        receptionWarehouseDataDone,
        productTypeOptions
    } = props
    
    const classes = useClasses()
    const storage = JSON.parse(localStorage.getItem("searchValue"))
    const searchFilter = (storage && storage.receptionWarehouseDataDone)?storage.receptionWarehouseDataDone:""

    return (
        <div className={classes.container}>
            <ReceptionWarehouseTable
                canOpen={false}
                tableType="done"
                receptionWarehouseData={receptionWarehouseDataDone}
                searchFilter={searchFilter}
                storageIndex="receptionWarehouseDone"
                modalRef={modalRef}
                productTypeOptions={productTypeOptions}
            />
        </div>
    )
}

export default connect((state) => {
    return {
        date: state.receptionWarehouse.date,
        productTypeOptions: state.receptionWarehouse.productTypeOptions
    }
}, {
})(ReceptionWarehouseDone)
